module.exports = __webpack_public_path__ + "static/media/special_store.8c9613f9.png";